import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }
  transform(url: any) {
    const value = String(url || '').trim();
    try {
      const parsedUrl = new URL(value);
      const isAllowedProtocol = parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:';
      const isBunnyHost = parsedUrl.hostname === 'iframe.mediadelivery.net' || parsedUrl.hostname.endsWith('.mediadelivery.net');
      const isBunnyEmbedPath = parsedUrl.pathname.startsWith('/embed/');
      if (!isAllowedProtocol || (!isBunnyHost && !isBunnyEmbedPath)) {
        return '';
      }
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    } catch {
      return '';
    }
  }

}
